var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "intro" } }, [
      _c("h2", [_vm._v("Systemvoraussetzungen")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c("p", [
          _vm._v(
            "Bei dieser Software handelt es sich um eine reine Web-Anwendung, welche als Infrastruktur einen\n                    Apache Tomcat benötigt. Auf den Einzelplatz-Rechnern ist keine Installation nötig. Die Benutzer greifen per\n                    Web-Browser auf die Anwendung zu."
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Installation des Servers kann unter Windows- oder Linux-Systemen erfolgen. Wir empfehlen 2 GB\n                    Hauptspeicher und 10GB Plattenplatz, falls die Datenbank auf dem gleichen Server installiert werden soll. Es kann\n                    allerdings auch schon auf bereits vorhandene Datenbanksysteme aufgesetzt werden."
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Die Kommunikation der Clients mit dem Server läuft standardmäßig über das Protokoll http und den Port\n                    8080. Der Port kann allerdings beliebig angepasst werden falls er schon belegt ist."
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v("Für den Betrieb von "),
            _c("riskop15"),
            _vm._v(" sind folgende Komponenten nötig:"),
          ],
          1
        ),
        _vm._v(" "),
        _c("ul", [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "li",
            [
              _vm._v(
                "Das ZIP-Archiv mit den Anwendungsdateien zum Deployment von "
              ),
              _c("riskop15"),
              _vm._v(": "),
              _c("strong", [_vm._v("riskop-1.5.x.zip")]),
              _vm._v("."),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", [_vm._v("Ihre Lizenz-Datei.")]),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Diese Anleitung führt Sie Schritt für Schritt durch die Installation. Die Links für die benötigten\n                    Downloads finden Sie direkt in den entsprechenden Abschnitten. Lediglich Ihre Lizenzdatei erhalten Sie\n                    per Email."
          ),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "selction" } }, [
          _c("p", [
            _vm._v(
              "Wir empfehlen Java 11, Tomcat 9 und PostreSQL als Umgebung. Alternativen können Sie hier\n                        auswählen:"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.osType,
                        expression: "osType",
                      },
                    ],
                    staticClass: "custom-select",
                    attrs: { id: "osType", name: "osType" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.osType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.osTypes, function (v) {
                    return _c(
                      "option",
                      { key: v.value, domProps: { value: v.value } },
                      [_vm._v(_vm._s(v.name))]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.javaVersion,
                        expression: "javaVersion",
                      },
                    ],
                    staticClass: "custom-select",
                    attrs: { id: "javaVersion", name: "javaVersion" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.javaVersion = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.javaVersions, function (v) {
                    return _c(
                      "option",
                      { key: v.value, domProps: { value: v.value } },
                      [_vm._v(_vm._s(v.name))]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tomcatVersion,
                        expression: "tomcatVersion",
                      },
                    ],
                    staticClass: "custom-select",
                    attrs: { id: "tomcatVersion", name: "tomcatVersion" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.tomcatVersion = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.tomcatVersions, function (v) {
                    return _c(
                      "option",
                      { key: v.value, domProps: { value: v.value } },
                      [
                        _vm._v(
                          _vm._s(v.name) + "\n                                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dbType,
                        expression: "dbType",
                      },
                    ],
                    staticClass: "custom-select",
                    attrs: { id: "dbType", name: "dbType" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.dbType = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.dbTypes, function (v) {
                    return _c(
                      "option",
                      { key: v.value, domProps: { value: v.value } },
                      [_vm._v(_vm._s(v.name))]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Installation der Java Laufzeitumgebung")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _vm.javaVersion == "9" ||
      _vm.javaVersion == "10" ||
      _vm.javaVersion == "12" ||
      _vm.javaVersion == "13" ||
      _vm.javaVersion == "14"
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _c("strong", [
              _vm._v("Hinweise zu Java " + _vm._s(_vm.javaVersion)),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "Java " +
                    _vm._s(_vm.javaVersion) +
                    ' ist eine Zwischenversion, für die es nur ein halbes Jahr nach\n                        Erscheinen Updates gibt. Daher empfehlen wir die aktuelle\n                        "LTS" Version: Java 11\n                    '
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.osType == "windows"
        ? _c("div", { staticClass: "card card-body" }, [
            _c("div", { staticClass: "alert alert-warning" }, [
              _c(
                "p",
                [
                  _vm._v(
                    "Oracle als Inhaber der Rechte hat 2019 die Lizenzierung von Java geändert und verlangt für die\n                        Nutzung seiner Distribution seitdem Lizenzgebühren. "
                  ),
                  _c("riskop15"),
                  _vm._v(
                    " funktioniert aber ohne\n                        Einschränkungen auch mit den Lizenz-freien Distributionen des OpenJDK, z.B. des unten genannten\n                        AdoptOpenJDK."
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'Wählen Sie dort "HotSpot" als JVM-Option und unter "Architecture" die zu Ihrem Server passende Architektur.'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'Als Download wählen Sie den "msi"-Windows-Installer in "JRE"-Version ("JDK" funktioniert auch, ist aber\n                    wesentlich größer).'
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Anschließend starten Sie bitte den Installer und folgen den angezeigten Anweisungen."
              ),
            ]),
            _vm._v(" "),
            _vm._m(5),
          ])
        : _vm.osType == "linux"
        ? _c("div", { staticClass: "card card-body" }, [
            _c("p", [
              _vm._v(
                "Unter Linux installieren Sie die passende JRE oder JDK-Version über den Packet-Manager Ihrer\n                    Linux-Distribution."
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Installation des DBMS")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _vm.dbType == "postgres"
        ? _c("div", [
            _vm.osType == "windows"
              ? _c("div", [
                  _c(
                    "p",
                    [
                      _vm._v(
                        _vm._s(_vm.dbName) +
                          " ist das von uns empfohlene DBMS für\n                        "
                      ),
                      _c("riskop15"),
                      _vm._v(
                        ". Mit diesem DBMS können wir Ihnen am besten bei Problemen helfen!\n                    "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Zunächst benötigen Sie den Installer für " +
                        _vm._s(_vm.dbName) +
                        " - diesen erhalten Sie per Download:"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(6),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _vm._m(8),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      'Bei der Abfrage, ob der "Stack-Builder"" gestartet werden soll, entfernen Sie bitte den Haken und\n                        schließen die Installation ab.'
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.osType == "linux"
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      "Installieren Sie " +
                        _vm._s(_vm.dbName) +
                        " mit Hilfe der Paketverwaltung Ihrer Linuxdistribution."
                    ),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dbType == "mssql"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "alert alert-warning" },
              [
                _c("riskop15"),
                _vm._v(
                  "\n                    kann den " +
                    _vm._s(_vm.dbName) +
                    " als DBMS nutzen, aber fumiX leistet keinen besonderen Support für den Betrieb\n                    des\n                    " +
                    _vm._s(_vm.dbName) +
                    ".\n                    Wir empfehlen die Nutzung für\n                    "
                ),
                _c("riskop15"),
                _vm._v(
                  "\n                    nur, wenn Sie den " +
                    _vm._s(_vm.dbName) +
                    " sowieso verwenden.\n                "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dbType == "mysql"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "alert alert-warning" },
              [
                _c("riskop15"),
                _vm._v(
                  "\n                    kann " +
                    _vm._s(_vm.dbName) +
                    " als DBMS nutzen, aber fumiX leistet keinen besonderen Support für dessen Betrieb.\n                    Wir empfehlen die Nutzung für\n                    "
                ),
                _c("riskop15"),
                _vm._v(
                  "\n                    nur, wenn Sie " +
                    _vm._s(_vm.dbName) +
                    " sowieso verwenden.\n                "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Anlegen der Datenbank")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", [
        _vm.dbType == "postgres"
          ? _c("div", [
              _vm.osType == "windows"
                ? _c("div", [
                    _c(
                      "p",
                      [
                        _vm._v(
                          "In diesem Schritt wird lediglich ein Benutzer und eine Datenbank angelegt. Die benötigten\n                            Tabellen\n                            werden später durch die Installationsroutine von\n                            "
                        ),
                        _c("riskop15"),
                        _vm._v(
                          "\n                            angelegt.\n                        "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(9),
                    _vm._v(" "),
                    _c(
                      "p",
                      [
                        _vm._v(
                          "Über das Kontextmenü über dem Eintrag\n                            "
                        ),
                        _c("em", [_vm._v("Login/Group Roles")]),
                        _vm._v(
                          " wählen Sie bitte\n                            "
                        ),
                        _c("em", [_vm._v("create")]),
                        _vm._v(
                          " aus. In dem nun folgenden Dialog vergeben Sie bitte den Benutzernamen\n                            "
                        ),
                        _c("code", [_vm._v("riskop")]),
                        _vm._v(
                          " sowie ein Passwort für diesen Benutzer. Es handelt sich dabei um einen\n                            technischen DB-Benutzer\n                            unter welchem sich die Anwendung dann gegen die Datenbank verbindet. Die Anwender von\n                            "
                        ),
                        _c("riskop15"),
                        _vm._v(
                          "\n                            benötigen keinen eigenen DB-Benutzer und werden später direkt in\n                            "
                        ),
                        _c("riskop15"),
                        _vm._v(
                          "\n                            über ein entsprechendes\n                            Web-Formular angelegt.\n                            Im Reiter "
                        ),
                        _c("em", [_vm._v("Privileges")]),
                        _vm._v(" aktivieren Sie den Schalter für "),
                        _c("code", [_vm._v("Can login?")]),
                        _vm._v(".\n                        "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._m(10),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.osType == "linux"
                ? _c("div", [
                    _c("p", [
                      _vm._v(
                        "Sie können die Konfiguration der Datenbank über die Kommandozeile vornehmen. Wird " +
                          _vm._s(_vm.dbName) +
                          "\n                            über die Paketverwaltung installiert, dann stehen auch Kommandozeilentools zum Anlegen von\n                            Benutzern und einrichten von Datenbanken zur Verfügung."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        'Die Kommandos werden als Unix-Benutzer "postgres" ausgeführt. Damit erfolgt die\n                            Authentifizierung gegen ' +
                          _vm._s(_vm.dbName) +
                          " über diesen Unix-Benutzer, und ein Passwort ist nicht notwendig."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _vm._m(11),
                      _vm._v(" "),
                      _vm._m(12),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v("Test\n                                "),
                        _c("pre", [
                          _vm._v("psql -h localhost -d riskop -U riskop"),
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c(
                            "li",
                            [
                              _vm._v(
                                "Das Passwort wird abgefragt.\n                                        "
                              ),
                              _c("code", [_vm._v("-h localhost")]),
                              _vm._v(
                                " stellt sicher, dass die Anmeldung über TCP erfolgt.\n                                        Dies ist der von "
                              ),
                              _c("riskop15"),
                              _vm._v(
                                " benötigte Anmeldemechanismus.\n                                    "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.dbType == "mssql"
          ? _c("div", [
              _c("p", [
                _vm._v(
                  "Legen Sie im " +
                    _vm._s(_vm.dbName) +
                    " einen Datenbank-User und eine Datenbank für riskop an. Der DB-User\n                        benötigt\n                        DDL-Rechte\n                        auf der riskop-Datenbank, da das Schema von der Anwendung anegelegt und bei Updates ggf.\n                        aktualisiert wird."
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.dbType == "mysql"
          ? _c("div", [
              _c("p", [
                _vm._v(
                  "Legen Sie im " +
                    _vm._s(_vm.dbName) +
                    " einen Datenbank-User und eine Datenbank für riskop an. Der DB-User\n                        benötigt\n                        DDL-Rechte\n                        auf der riskop-Datenbank, da das Schema von der Anwendung anegelegt und bei Updates ggf.\n                        aktualisiert wird."
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("h2", [
      _vm._v("Download und Installation vom Apache Tomcat Application Server"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "p",
        [
          _vm._v("Apache Tomcat ist ein "),
          _c("em", [_vm._v("Application Server")]),
          _vm._v(" für Java Web Anwendungen und wird von\n                "),
          _c("riskop15"),
          _vm._v(
            "\n                benötigt.\n                Tomcat muss hierzu auf dem Windows-Server als Service installiert werden.\n            "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.osType == "windows"
        ? _c("div", [
            _vm.tomcatVersion == 8
              ? _c(
                  "div",
                  { staticClass: "alert alert-warning" },
                  [
                    _vm._v(
                      "\n                    Tomcat " +
                        _vm._s(_vm.tomcatVersion) +
                        " ist mittlerweile veraltet und sollte für Neu-Installationen nicht\n                    verwendet\n                    werden, es sei denn\n                    Sie möchten\n                    "
                    ),
                    _c("riskop15"),
                    _vm._v(
                      "\n                    in einem bereits vorhanden Tomcat " +
                        _vm._s(_vm.tomcatVersion) +
                        " installieren.\n                    "
                    ),
                    _c("p", [
                      _vm._v(
                        "Sie können den Tomcat " +
                          _vm._s(_vm.tomcatVersion) +
                          " für " +
                          _vm._s(_vm.osType) +
                          "\n                        "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://tomcat.apache.org/download-80.cgi",
                            target: "_blank",
                          },
                        },
                        [
                          _vm._v(
                            "hier bei der Apache\n                            Software\n                            Foundation"
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n                        herunterladen.\n                    "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm.tomcatVersion == 9
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      "Sie können den Tomcat " +
                        _vm._s(_vm.tomcatVersion) +
                        " für " +
                        _vm._s(_vm.osType) +
                        "\n                        "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://tomcat.apache.org/download-90.cgi",
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "hier bei der Apache\n                            Software\n                            Foundation"
                        ),
                      ]
                    ),
                    _vm._v(
                      "\n                        herunterladen.\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm._m(13),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v(
                    "Normalerweise installiert sich der Tomcat in\n                        "
                  ),
                  _c("tomcat-path", { attrs: { os: _vm.osType, path: "" } }),
                  _vm._v(
                    "\n                        , mit kleinen Abweichungen je nach\n                        Architktur (32/64 bit) und Tomcat-Version. In diesem Tomcat-Verzeichnis spielt sich im weiteren\n                        die\n                        Installation und\n                        Konfiguration ab. Sie können den Tomcat auch in ein anderes Verzeichnis installieren - dann\n                        ändern\n                        sich entsprechend\n                        auch die unten genannten Pfade für die zu installierenden Dateien!\n                    "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(14),
            ]),
          ])
        : _vm.osType == "linux"
        ? _c("div", [
            _c("p", [
              _vm._v(
                "Unter Linux empfielt es sich den passenden Tomcat einfach über den Packet-Manager Ihrer\n                    Linux-Distribution\n                    zu installieren und aktuell zu halten. Voraussetzung ist aber ein Tomcat mindestens in Version\n                    7!"
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "alert alert-warning" },
              [
                _vm._v(
                  "\n                    Der Tomcat wird je nach Linux-Distribution unterschiedlich installiert. Meistens findet sich das\n                    Tomcat-Installationsverzeichnis,\n                    in das auch Anwendungsdatei "
                ),
                _c("code", [_vm._v("riskop.war")]),
                _vm._v(
                  " und die Konfigurationsdateien gelegt werden,\n                    unter\n                    "
                ),
                _c("tomcat-path", { attrs: { os: _vm.osType, path: "" } }),
                _vm._v("\n                    .\n                "),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h2", { attrs: { id: "tomcat" } }, [_vm._v("Tomcat Konfiguration")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "p",
        [
          _vm._v(
            "Die zentrale Konfiguration für den Tomcat befindet sich im Tomcat-Installationsverzeichnis in der Datei\n                "
          ),
          _c("tomcat-path", {
            attrs: { os: _vm.osType, path: "conf/server.xml" },
          }),
          _vm._v(
            "\n                . Hier\n                sind folgende Anpassungen notwendig:"
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(15),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("Änderungen in der\n                "),
          _c("tomcat-path", {
            attrs: { os: _vm.osType, path: "conf/server.xml" },
          }),
          _vm._v(
            "\n                werden nach dem Neustart des Tomcat wirksam.\n            "
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Download und Installation des Datenbanktreibers")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "p",
        [
          _vm._v("Zum Zugriff auf die Datenbank benötigt\n                "),
          _c("riskop15"),
          _vm._v(
            "\n                noch einen Treiber für die Datenbank. Die Auswahl ist abhängig von der verwendeten Java-Version\n                und dem DBMS:"
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dbType == "postgres"
        ? _c("div", [
            _c("p", [
              _vm._v(
                "Für " +
                  _vm._s(_vm.dbName) +
                  " finden Sie die aktuellen Treiber bei "
              ),
              _c(
                "a",
                {
                  attrs: {
                    title: "PG JDBC",
                    href: "https://jdbc.postgresql.org/download.html#current",
                    target: "_blank",
                  },
                },
                [_vm._v("Postgres JDBC Downloads")]
              ),
              _vm._v(
                ".\n                    Wählen Sie hier den aktuellen Treiber. Für Java " +
                  _vm._s(_vm.javaVersion) +
                  " wird der\n                    "
              ),
              _vm._m(16),
              _vm._v(
                "\n                    Treiber benötigt.\n                "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dbType == "mssql"
        ? _c("div", [_vm._m(17), _vm._v(" "), _vm._m(18)])
        : _vm._e(),
      _vm._v(" "),
      _vm.dbType == "mysql"
        ? _c("div", [
            _c("p", [
              _vm._v(
                "Den JDBC-Treiber zu " +
                  _vm._s(_vm.dbName) +
                  " finden Sie auf\n                    "
              ),
              _c(
                "a",
                {
                  attrs: {
                    title: "MySQL JDBC",
                    href: "https://dev.mysql.com/downloads/connector/j/",
                    target: "_blank",
                  },
                },
                [_vm._v("Connector-J\n                        Downloads")]
              ),
              _vm._v("."),
            ]),
            _vm._v(" "),
            _vm._m(19),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v(
            "Den heruntergeladenen Datenbanktreiber (eine Datei mit der Endung "
          ),
          _c("code", [_vm._v(".jar")]),
          _vm._v(
            ") kopieren Sie im Tomcat\n                in das Verzeichnis "
          ),
          _c("tomcat-path", { attrs: { os: _vm.osType, path: "lib/" } }),
          _vm._v(".\n            "),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Download von riskop")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "p",
        [
          _vm._v("Die für das Deployment von\n            "),
          _c("riskop15"),
          _vm._v("\n            notwendigen Java-Web-Anwendung "),
          _c("code", [_vm._v("riskop.war")]),
          _vm._v(" und die Konfigurationsdatei\n            "),
          _c("code", [_vm._v("riskop.properties")]),
          _vm._v(" befinden\n            sich in einem ZIP-Archiv.\n        "),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(20),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Deployment und Konfiguration von riskop")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "alert alert-warning" }, [
        _vm._v(
          "\n            Achten Sie bitte darauf, dass für diesen Schritt der Tomcat-Dienst nicht gestartet ist!\n        "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Im riskop-ZIP-Archiv befinden sich die Dateien, die Sie an die richtigen Stellen in das Verzeichnis Ihrer\n            Tomcat-Installation kopieren müssen:"
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c(
          "li",
          [
            _c("code", [_vm._v("riskop.war")]),
            _vm._v(" in das Unter-Verzeichnis\n                "),
            _c("tomcat-path", { attrs: { os: _vm.osType, path: "webapps/" } }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("code", [_vm._v("riskop.properties")]),
            _vm._v("  in dasUnter-Verzeichnis\n                "),
            _c("tomcat-path", { attrs: { os: _vm.osType, path: "conf/" } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v(" Die Konfiguration zu\n            "),
          _c("riskop15"),
          _vm._v("\n            befindet sich in der Datei\n            "),
          _c("tomcat-path", {
            attrs: { os: _vm.osType, path: "conf/riskop.properties" },
          }),
        ],
        1
      ),
      _c("h3", [_vm._v("Datenbank-Verbindung")]),
      _vm._v(" "),
      _vm._m(21),
      _vm._v(" "),
      _c("div", [
        _vm.dbType == "postgres"
          ? _c("div", [
              _c(
                "p",
                [
                  _vm._v("Die "),
                  _c("code", [_vm._v("db.connection.url")]),
                  _vm._v(
                    " für " + _vm._s(_vm.dbName) + " enthält die Kennung "
                  ),
                  _c("code", [_vm._v("postgresql")]),
                  _vm._v(
                    ". Als\n                    Server ist\n                    hier "
                  ),
                  _c("code", [_vm._v("localhost")]),
                  _vm._v(
                    " eingetragen, wenn " +
                      _vm._s(_vm.dbName) +
                      " auf dem gleichen Server installiert ist\n                    wie\n                    "
                  ),
                  _c("riskop15"),
                  _vm._v(
                    "\n                    und mit dem Standard-Port 5432 läuft. Alternativ kann statt 'localhost' der Servername und der Port\n                    spezifiziert werden, z.B.\n                    "
                  ),
                  _c("code", [_vm._v("riskop-db-server.local:2345")]),
                  _vm._v(".\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(22),
            ])
          : _vm.dbType == "mssql"
          ? _c("div", [
              _c(
                "div",
                { staticClass: "alert alert-warning" },
                [
                  _vm._v("\n                    Damit\n                    "),
                  _c("riskop15"),
                  _vm._v(
                    "\n                    per JDBC-Datenbanktreiber auf den " +
                      _vm._s(_vm.dbName) +
                      " zugreifen kann, muss dieser für Remote-Verbindungen\n                    freigeschaltet werden. Weiter Informationen hierzu für\n                    "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://support.microsoft.com/de-de/help/914277/how-to-configure-sql-server-2005-to-allow-remote-connections",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dbName) + " 2005")]
                  ),
                  _vm._v(",\n                    "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.windowspro.de/tipp/sql-server-express-fuer-remote-zugriff-konfigurieren",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dbName) + " 2008")]
                  ),
                  _vm._v(" oder\n                    "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://docs.microsoft.com/de-de/sql/database-engine/configure-windows/configure-the-remote-access-server-configuration-option?view=sql-server-2017",
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.dbName) + " 2017")]
                  ),
                  _vm._v(".\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm._v("Die "),
                  _c("code", [_vm._v("db.connection.url")]),
                  _vm._v(
                    " für den " + _vm._s(_vm.dbName) + " enthält die Kennung "
                  ),
                  _c("code", [_vm._v("sqlserver")]),
                  _vm._v(
                    ".\n                    Als Server ist\n                    hier "
                  ),
                  _c("code", [_vm._v("localhost")]),
                  _vm._v(
                    " eingetragen, wenn der " +
                      _vm._s(_vm.dbName) +
                      " auf dem gleichen Server installiert\n                    ist wie\n                    "
                  ),
                  _c("riskop15"),
                  _vm._v(
                    "\n                    und mit dem Standard-Port 1433 läuft. Alternativ kann statt 'localhost' der Servername und der Port\n                    spezifiziert werden, z.B.\n                    "
                  ),
                  _c("code", [_vm._v("riskop-db-server.local:3341")]),
                  _vm._v(".\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(23),
            ])
          : _vm.dbType == "mysql"
          ? _c("div", [
              _c(
                "p",
                [
                  _vm._v("Die "),
                  _c("code", [_vm._v("db.connection.url")]),
                  _vm._v(
                    " für den " + _vm._s(_vm.dbName) + " enthält die Kennung "
                  ),
                  _c("code", [_vm._v("mysql")]),
                  _vm._v(
                    ". Als\n                    Server ist\n                    hier "
                  ),
                  _c("code", [_vm._v("localhost")]),
                  _vm._v(
                    " eingetragen, wenn " +
                      _vm._s(_vm.dbName) +
                      " auf dem gleichen Server installiert ist\n                    wie\n                    "
                  ),
                  _c("riskop15"),
                  _vm._v(
                    "\n                    und mit dem Standard-Port 3306 läuft. Alternativ kann statt 'localhost' der Servername und der Port\n                    spezifiziert werden, z.B.\n                    "
                  ),
                  _c("code", [_vm._v("riskop-db-server.local:6033")]),
                ],
                1
              ),
              _vm._v("\n                .\n                "),
              _vm._m(24),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Initialisierung der Datenbank")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Jetzt kann der Tomcat Dienst gestartet werden. Falls Sie den Standard-Port des Tomcat nicht geändert haben,\n            sollten\n            sich folgende URLs (auf dem Server) direkt aufrufen lassen. Ansonsten ist natürlich die Port-Angabe der URLs\n            entsprechend anzupassen.\n        "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Wenn der Dienst vollständig gestartet ist (das kann das erste Mal bis zu einer Minute dauern) kann die\n            Installation\n            durch Start der Installationsroutine über folgende URL fertig gestellt werden:"
        ),
      ]),
      _vm._v(" "),
      _vm._m(25),
      _vm._v(" "),
      _vm._m(26),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v(
            "Mit diesem Benutzer und dem angezeigten Passwort können Sie sich nun über folgende URL im Backend von\n            "
          ),
          _c("riskop15"),
          _vm._v("\n            anmelden:\n        "),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(27),
      _vm._v(" "),
      _vm._m(28),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Die anonyme Meldeseite ist einfach unter folgender URL zu erreichen:"
        ),
      ]),
      _vm._v(" "),
      _vm._m(29),
      _vm._v(" "),
      _c("p", { staticClass: "alert alert-success" }, [
        _vm._v(
          "Herzlichen Glückwunsch - damit ist die Installation des Systems\n            abgeschlossen!"
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Backup einrichten")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("p", [
        _vm._v(
          "Die erfassten Daten sollten natürlich regelmäßig per Backup gesichert werden!"
        ),
      ]),
      _vm._v(" "),
      _vm.dbType == "postgres"
        ? _c("div", [
            _c(
              "p",
              [
                _vm._v(
                  "Für " + _vm._s(_vm.dbName) + " kann das mit dem Kommando "
                ),
                _c("br"),
                _vm._v(" "),
                _c("pg-cmd", {
                  attrs: {
                    os: _vm.osType,
                    cmd: "pg_dump",
                    args: " -U riskop -f riskop_backup.sql riskop",
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                im laufenden Betrieb erledigt werden.\n            "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(30),
            _vm._v(" "),
            _c("p", [_vm._v("Die Parameter im einzelnen:")]),
            _vm._v(" "),
            _vm._m(31),
            _vm._v(" "),
            _vm._m(32),
            _vm._v(" "),
            _vm._m(33),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Wenn diese Kommandos aus einem Script aufgerufen werden sollen kann die Passwortabfrage folgendermaßen\n                umgangen werden:"
              ),
            ]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v('Sie können in der Datei "pg_hba.conf" im Verzeichnis '),
                _c("code", [_vm._v("data")]),
                _vm._v(
                  " Ihrer " +
                    _vm._s(_vm.dbName) +
                    "-Installation folgende Zeile am Ende hinzufügen:\n                    "
                ),
                _c("pre", [
                  _vm._v("host riskop riskop-admin 127.0.0.1/32 trust"),
                ]),
                _vm._v(
                  "\n                    Damit ist vom lokalen Rechner aus der Zugriff auf die Datenbank\n                    "
                ),
                _c("code", [_vm._v("riskop")]),
                _vm._v(" für den Benutzer "),
                _c("code", [_vm._v("riskop-admin")]),
                _vm._v(
                  " allerdings gar nicht mehr geschützt.\n                    Von allen anderen Rechnern aus aber schon.\n                "
                ),
              ]),
              _vm._v(" "),
              _vm._m(34),
            ]),
          ])
        : _c("div", [
            _c("p", [
              _vm._v(
                "Für " +
                  _vm._s(_vm.dbName) +
                  " können wir hierzu leider keinen Support anbieten. Bitte folgen Sie der\n                Hersteller-Dokumentation des DBMS."
              ),
            ]),
          ]),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Optionale Konfiguration")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("h3", [
        _vm._v("Empfohlene Konfiguration für Zugriff aus dem Internet"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-8" }, [
          _c("img", {
            staticClass: "img-fluid",
            attrs: { src: _vm.imagepath + "/CIRSmobile-Arch-grey.svg" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4" }, [
          _c(
            "p",
            [
              _vm._v("Falls\n                    "),
              _c("riskop15"),
              _vm._v(
                "\n                    aus dem Internet erreichbar sein soll, empfehlen wir einen Apache Web-Server vorzuschalten und die\n                    gesamte Kommunikation per SSL zu verschlüsseln.\n                "
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "So kann über die Konfiguration des Web-Servers z.B. auch nur die Meldeseite im Internet verfügbar gemacht\n            werden, so dass der Zugriff des Backends weiterhin nur aus dem Intranet möglich ist."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Wenn Sie hier Unterstützung brauchen kommen Sie gerne auf uns zu!"
        ),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("E-Mail-Versand einrichten")]),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("Damit\n            "),
          _c("riskop15"),
          _vm._v(
            "\n            Email-Benachrichtigungen verschicken kann, kann eine Anbindung an Ihren SMTP-Server eingerichtet werden.\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("Dazu sind folgende Einträge in der Datei\n            "),
          _c("tomcat-path", {
            attrs: { os: _vm.osType, path: "conf/riskop.properties" },
          }),
          _vm._v("\n            anzupassen:\n        "),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(35),
      _vm._v(" "),
      _vm._m(36),
      _vm._v(" "),
      _c("p", [_vm._v("Anschließend ist der Tomcat-Dienst neu zu starten.")]),
      _vm._v(" "),
      _c("h3", [
        _vm._v(
          "Anbindung an einrichtungsübergreifendes Fehlermeldesystem CIRSmedical"
        ),
      ]),
      _vm._v(" "),
      _vm._m(37),
      _vm._v(" "),
      _vm._m(38),
      _vm._v(" "),
      _vm._m(39),
      _vm._v(" "),
      _c("p", [_vm._v(" ")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Mehrere Riskop-Instanzen auf einem Server")]),
      _vm._v(" "),
      _c(
        "p",
        [
          _c("riskop15"),
          _vm._v(
            "\n            kann innerhalb einer Tomcat-Installation mehrfach mit Zugriff auf unterschiedliche\n            Datenbank-Instanzen zur Verfügung gestellt werden.\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "alert alert-info",
          staticStyle: { "word-break": "break-all" },
        },
        [
          _c("riskop15"),
          _vm._v("\n            -Instanzen im Tomcat werden durch ihre "),
          _c("em", [_vm._v("Kontext-Namen")]),
          _vm._v(
            " unterschieden. Dieser ergibt sich aus dem\n            Namen\n            der "
          ),
          _c("em", [_vm._v("war")]),
          _vm._v("-Datei, die nach\n            "),
          _c("tomcat-path", { attrs: { os: _vm.osType, path: "webapps/" } }),
          _vm._v("\n            kopiert wird. Im Normalfall heißt die Datei "),
          _c("em", [_vm._v("riskop.war")]),
          _vm._v("\n            und der Kontext-Name ist "),
          _c("em", [_vm._v("riskop")]),
          _vm._v(". Aus dem Kontext-Namen ergeben sich\n            "),
          _c("ul", [
            _vm._m(40),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm._v(
                  "Der Name der zugehörigen Konfigurationsdatei\n                    "
                ),
                _c("tomcat-path", {
                  attrs: {
                    os: _vm.osType,
                    path: "conf/<Kontext-Name>.properties",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _vm._v("Der Name des Logfiles im\n                    "),
                _c("tomcat-path", { attrs: { os: _vm.osType, path: "logs/" } }),
                _vm._v("\n                    Verzeichnis.\n                "),
              ],
              1
            ),
          ]),
          _vm._v(
            "\n            Sie können also mehrere riskop-Instanzen in einem Tomcat installieren, indem Sie die Datei riskop.war\n            mehrfach mit unterschiedlichem Namen\n            im\n            "
          ),
          _c("tomcat-path", { attrs: { os: _vm.osType, path: "webapps/" } }),
          _vm._v(
            "\n            -Verzeichnis ablegen und für jede Instanz eine eigene Properties-Datei mit passendem Namen anlegen.\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(41),
      _vm._v(" "),
      _c("p", [_vm._v("Führen Sie dazu folgende Schritte aus:")]),
      _vm._v(" "),
      _c("ol", [
        _vm._m(42),
        _vm._v(" "),
        _vm._m(43),
        _vm._v(" "),
        _c("li", [
          _c(
            "p",
            [
              _vm._v("Von dem bestehenden\n                    "),
              _c("tomcat-path", {
                attrs: { os: _vm.osType, path: "webapps/riskop.war" },
              }),
              _vm._v(
                "\n                    -File ist eine Kopie\n                    "
              ),
              _c("tomcat-path", {
                attrs: { os: _vm.osType, path: "webapps/bsp_riskop" },
              }),
              _vm._v("\n                    zu erzeugen.\n                "),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "p",
            [
              _vm._v("Von der Datei\n                    "),
              _c("tomcat-path", {
                attrs: { os: _vm.osType, path: "conf/riskop.properties" },
              }),
              _vm._v(
                "\n                    ist analog eine Kopie namens\n                    "
              ),
              _c("tomcat-path", {
                attrs: { os: _vm.osType, path: "conf/bsp_riskop.properties" },
              }),
              _vm._v(
                "\n                    zu erstellen. In dieser Datei müssen die Datenbank-Verbindungsparameter\n                    für die neuen Instanz angepasst werden.\n                "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-warning" }, [
            _vm._v(
              "\n                    Jede riskop-Instanz benötigt eine eigene Datenbank-Instanz. Die Daten der riskop-Instanzen sind\n                    dadurch\n                    vollständig voneinander getrennt.\n                "
            ),
          ]),
          _vm._v(" "),
          _vm._m(44),
          _vm._v(" "),
          _c("p", [
            _vm._v("Beispiel (für PostgreSQL, analog für die anderen DBMS):"),
          ]),
          _vm._v(" "),
          _vm._m(45),
        ]),
        _vm._v(" "),
        _vm._m(46),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Ein DBMS (empfohlen: "),
      _c("strong", [_vm._v("PostgreSQL 12")]),
      _vm._v(", alternativ PostgreSQL 9-11, MySQL oder MS-SQL-Server)."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Java ab Version 8 (empfohlen: "),
      _c("strong", [_vm._v("Java 11")]),
      _vm._v(")."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Apache Tomcat ab Version 7 (empfohlen: "),
      _c("strong", [_vm._v("Tomcat 9")]),
      _vm._v(")."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Um die aktuelle Java-Version von "),
      _c("strong", [_vm._v("AdoptOpenJDK")]),
      _vm._v(
        " für Ihren Windows-Server herunter zu laden, verwenden Sie\n                    folgenden Link:"
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        { attrs: { href: "https://adoptopenjdk.net/", target: "_blank" } },
        [_vm._v("https://adoptopenjdk.net/")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-secondary" }, [
      _c("p", [
        _vm._v("Alternativer Java-Download vom OracleJDK: "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.oracle.com/java/technologies/javase-downloads.html",
              target: "_blank",
            },
          },
          [
            _vm._v(
              "https://www.oracle.com/java/technologies/javase-downloads.html"
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Wählen Sie hier das Java SE Development Kit in gewünschter Version, passend zu Ihrer Server-Architektur."
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Bis Java 8 können Sie noch das kleinere JRE auswählen, ab Version 11 erhalten Sie hier nur noch das\n                        Software Development Kit, das eigentlich nicht mehr für den produktiv Betrieb vorgesehen ist."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            title: "PostgreSQL Installer",
            href: "https://www.enterprisedb.com/downloads/postgres-postgresql-downloads",
            target: "_blank",
          },
        },
        [
          _vm._v(
            "https://www.enterprisedb.com/downloads/postgres-postgresql-downloads"
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-warning" }, [
      _c("p", [
        _vm._v(
          "Damit alles reibungslos funktioniert, empfehlen wir die Installation unter dem\n                            "
        ),
        _c("em", [_vm._v("lokalen Administrator")]),
        _vm._v(
          " auszuführen. Wenn Sie als Domänen-Administrator angemeldet\n                            sind, wird wahrscheinlich die Installation abbrechen!"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Der Installer führt Sie per Dialog durch die Installation. Bitte notieren Sie sich das Passwort,\n                        dass Sie für den Dienste-Benutzer "
      ),
      _c("code", [_vm._v("postgres")]),
      _vm._v(" vergeben - Sie werden es später noch benötigen!"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Über das Startmenü können Sie nun die Anwendung\n                            "
      ),
      _c("strong", [_vm._v("PgAdmin IV")]),
      _vm._v(
        " starten. Durch Doppelklick auf den (einzigen) Servereintrag\n                            "
      ),
      _c("code", [_vm._v("postgres")]),
      _vm._v(
        " verbinden Sie sich mit dem DB-Server. Hier werden Sie nun nach dem\n                            Dienstepasswort gefragt welches\n                            Sie bei der Installation vergeben haben."
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Anschließend wird über das Kontextmenü des Eintrags\n                            "
      ),
      _c("em", [_vm._v("Databases")]),
      _vm._v(" der Punkt\n                            "),
      _c("em", [_vm._v("create")]),
      _vm._v(
        " ausgewählt. Als Datenbankname vergeben Sie hier bitte\n                            "
      ),
      _c("code", [_vm._v("riskop")]),
      _vm._v(
        '. Als "Owner" wählen Sie einfach den im vorherigen Schritt angelegten\n                            Benutzer\n                            '
      ),
      _c("code", [_vm._v("riskop")]),
      _vm._v(
        " aus. Im 2. Reiter wählen Sie als Vorlage\n                            "
      ),
      _c("code", [_vm._v("template0")]),
      _vm._v(" aus und als Tablespace\n                            "),
      _c("code", [_vm._v("pg_default")]),
      _vm._v(".\n                            "),
      _c("strong", [
        _vm._v("Als Encoding sollte "),
        _c("code", [_vm._v("UTF-8")]),
        _vm._v(" ausgewählt sein."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Benutzer anlegen (Benutzer\n                                "),
      _c("code", [_vm._v("riskop")]),
      _vm._v(", mit Passwort)\n                                "),
      _c("pre", [_vm._v("sudo -u postgres createuser riskop -P")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Datenbank anlegen (DB "),
      _c("code", [_vm._v("riskop")]),
      _vm._v(" für Owner "),
      _c("code", [_vm._v("riskop")]),
      _vm._v(", mit UTF8)\n                                "),
      _c("pre", [_vm._v("sudo -u postgres createdb -O riskop -E UTF8 riskop")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Für Windows Server empfehlen wir die Variante\n                        "
      ),
      _c("strong", [_vm._v("32-bit/64-bit Windows Service Installer")]),
      _vm._v(
        ". Nach dem Download starten Sie bitte\n                        den\n                        Installer\n                        und folgen den Anweisungen. Falls kein weiter Webserver auf Port 80 läuft und die Anwendung nur\n                        im Intranet erreichbar sein soll, können Sie den Port im entsprechenden Feld des Installers von\n                        8080 auf 80 ändern. Damit entfällt später die Angabe des Ports in der URL zum Aufruf der\n                        Anwendung\n                        im Webbrowser."
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Bevor der Tomcat später gestartet wird, sollte noch der maximal für den Tomcat zur Verfügung\n                        stehende\n                        Speicher erhöht werden. Starten Sie dazu im Startmenü die Anwendung\n                        "
      ),
      _c("em", [_vm._v("Monitor Tomcat")]),
      _vm._v(
        ". Es erscheint die Monitor-Anwendung in der Taskbar und Sie können über\n                        die\n                        rechte Maustaste den Punkt\n                        "
      ),
      _c("em", [_vm._v("Configure")]),
      _vm._v(
        " auswählen. In dem nun erscheinenden Fenster wählen Sie den Reiter\n                        "
      ),
      _c("em", [_vm._v("Java")]),
      _vm._v(" aus und tragen in das Feld\n                        "),
      _c("em", [_vm._v("Java-Optionen")]),
      _vm._v(" den Wert\n                        "),
      _c("code", [_vm._v("-Xmx512m")]),
      _vm._v(" ein."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("p", [
          _vm._v("Ergänzen Sie den Eintrag für den "),
          _c("code", [_vm._v("Connector")]),
          _vm._v(" um das Attribut "),
          _c("code", [_vm._v("maxHttpHeaderSize")]),
          _vm._v(":"),
        ]),
        _vm._v(" "),
        _c("pre", [
          _vm._v(
            '<Connector port="8080" protocol="HTTP/1.1" connectionTimeout="20000" redirectPort="8443"  '
          ),
          _c("strong", [_vm._v('maxHttpHeaderSize="65536"')]),
          _vm._v("/>"),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "alert alert-warning" }, [
          _c("strong", [_vm._v("Protokollierung der Zugriffe ausschalten:")]),
          _vm._v(
            ' Eine\n                        zugesicherte Eigenschaft unseres CIRS riskop\n                        ist die anonyme Erfassung der Meldungen. Dies erfordert, dass keine IP-Adressen der Meldenden\n                        protokolliert werden.\n                        Entfernen Sie hierzu den Eintrag "AccessLogValve" in der server.xml:\n                    '
          ),
        ]),
        _vm._v(" "),
        _c("pre", [
          _vm._v(
            '<Valve className="org.apache.catalina.valves.AccessLogValve" '
          ),
          _c("br"),
          _vm._v('    directory="logs"'),
          _c("br"),
          _vm._v('    prefix="localhost_access_log" suffix=".txt"'),
          _c("br"),
          _vm._v('    pattern="%h %l %u %t &quot;%r&quot; %s %b" />'),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("strong", [_c("span", [_vm._v(" JDBC 4.2")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Den JDBC-Treiber zum MS SQL Server finden auf\n                    "
      ),
      _c(
        "a",
        {
          attrs: {
            title: "MS SQL JDBC",
            href: "https://docs.microsoft.com/de-de/sql/connect/jdbc/download-microsoft-jdbc-driver-for-sql-server",
            target: "_blank",
          },
        },
        [
          _vm._v(
            "https://docs.microsoft.com/de-de/sql/connect/jdbc/download-microsoft-jdbc-driver-for-sql-server"
          ),
        ]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Beachten Sie bitte, ab Java 8 wird der "),
      _c("code", [_vm._v("JDBC 4.2")]),
      _vm._v(" Treiber\n                    benötigt."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Bitte beachten Sie, dass Sie Informationen zur Kompatiblität der Treiber-Versionen auf\n                    "
      ),
      _c(
        "a",
        {
          attrs: {
            title: "MySQL JDBC",
            href: "https://dev.mysql.com/doc/connector-j/8.0/en/connector-j-versions.html",
            target: "_blank",
          },
        },
        [_vm._v("Connector-J Versionen")]
      ),
      _vm._v(" finden.\n                "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Dieses Archiv können Sie unter\n            "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.fumix.de/kunden-login",
            target: "_blank",
          },
        },
        [_vm._v("Kunden-Login")]
      ),
      _vm._v(
        " herunterladen, nachdem Sie sich\n            dort durch Upload Ihrer aktuellen\n            Lizenz authentifiziert haben.\n        "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Übernehmen Sie die folgenden Zeilen in Ihren "),
      _c("code", [_vm._v("riskop.properties")]),
      _vm._v(". Als "),
      _c("code", [_vm._v("Datenbank")]),
      _vm._v(
        "\n            tragen Sie bitte den Namen der oben angelegten Datenbank ein. "
      ),
      _c("code", [_vm._v("Datenbank-User")]),
      _vm._v(" und\n            "),
      _c("code", [_vm._v("Datenbank-Passwort")]),
      _vm._v(
        " sind die Zugangsdaten von dem Datenbank-Nutzer, den Sie für die "
      ),
      _c("code", [_vm._v("Datenbank")]),
      _vm._v("\n            angelegt haben."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("db.connection.url=jdbc:postgresql://localhost/"),
      _c("strong", [_vm._v("Datenbank")]),
      _vm._v("\ndb.connection.username="),
      _c("strong", [_vm._v("Datenbank-User")]),
      _vm._v("\ndb.connection.password="),
      _c("strong", [_vm._v("Datenbank-Passwort")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("\tdb.connection.url=jdbc:sqlserver://localhost;databaseName="),
      _c("strong", [_vm._v("Datenbank")]),
      _vm._v("\n\tdb.connection.username="),
      _c("strong", [_vm._v("Datenbank-User")]),
      _vm._v("\n\tdb.connection.password="),
      _c("strong", [_vm._v("Datenbank-Passwort")]),
      _vm._v("\n\t\t\t\t"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("\tdb.connection.url=jdbc:mysql://localhost:3306/"),
      _c("strong", [_vm._v("Datenbank")]),
      _vm._v("\n\tdb.connection.username="),
      _c("strong", [_vm._v("Datenbank-User")]),
      _vm._v("\n\tdb.connection.password="),
      _c("strong", [_vm._v("Datenbank-Passwort")]),
      _vm._v("\n\t\t\t\t"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            href: "http://localhost:8080/riskop/admin/Start.do",
            target: "_blank",
          },
        },
        [_vm._v("http://localhost:8080/riskop/admin/Start.do")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Hier werden Sie nun aufgefordert Ihre Lizenzdatei in das System zu laden. Danach werden durch Klick auf\n            den Button "
      ),
      _c("em", [_vm._v("Datenbank initialisieren")]),
      _vm._v(
        " und anschließende Bestätigung alle benötigten\n            Datenbank-Tabellen sowie ein\n            initialer Benutzer angelegt."
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            href: "http://localhost:8080/riskop/team/Start.do",
            target: "_blank",
          },
        },
        [_vm._v("http://localhost:8080/riskop/team/Start.do")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Hier können nun weitere Benutzer, Meldekreise sowie die Stammdaten angelegt werden. Üblicherweise geschieht\n            das\n            im Rahmen einer entsprechenden Schulung durch Berater der\n            "
      ),
      _c(
        "a",
        {
          attrs: { title: "GRB", href: "http://www.grb.de", target: "_blank" },
        },
        [_vm._v("GRB Gesellschaft für Risiko-Beratung mbH")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        { attrs: { href: "http://localhost:8080/riskop", target: "_blank" } },
        [_vm._v("http://localhost:8080/riskop")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Damit sichern Sie alle Daten der Datenbank\n                "),
      _c("code", [_vm._v("riskop")]),
      _vm._v(" in die Datei\n                "),
      _c("code", [_vm._v("riskop_backup.sql")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("code", [_vm._v("-U")]),
      _vm._v(
        " gibt den DB-User an, dem die Datenbank gehört - normalerweise ist das der Benutzer\n                "
      ),
      _c("code", [_vm._v("riskop")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("code", [_vm._v("-f")]),
      _vm._v(
        " gibt den Pfad- oder Dateinamen für die gesicherten\n                Daten an."
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Der letzte Parameter ist der Name der zu sichernden Datenbank - normalerweise ist das\n                "
      ),
      _c("code", [_vm._v("riskop")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v(" Sie können im aufrufenden Script die Umgebungsvariable "),
      _c("code", [_vm._v("PGPASSWORD")]),
      _vm._v(
        " mit dem Passwort\n                    setzen.\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("SMTP_HOST="),
      _c("em", [_vm._v("ihr.smtp.server")]),
      _vm._v("\nSMTP_USER=\nSMTP_PWD=\nFROM_NAME=riskop\nFROM_ADDRESS=riskop@"),
      _c("em", [_vm._v("...ihre-einrichtung..de")]),
      _vm._v("\nREPLY_TO=admin@"),
      _c("em", [_vm._v("...ihre-einrichtung..de")]),
      _vm._v("\n\t"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Falls Ihr SMTP-Server eine Authentifizierung benötigt, legen Sie am besten einen technischen Email-Account an\n            und tragen die entsprechenden Daten unter\n            "
      ),
      _c("code", [_vm._v("SMTP_USER")]),
      _vm._v(" und\n            "),
      _c("code", [_vm._v("SMTP_PWD")]),
      _vm._v(" ein."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("a", { attrs: { id: "CIRSmedical-Konfiguration" } }),
      _vm._v("Das Weiterleiten von CIRS-Meldungen aus riskop an\n            "),
      _c(
        "a",
        {
          staticClass: "external text",
          attrs: {
            href: "http://www.cirsmedical.de/",
            target: "_blank",
            rel: "nofollow",
          },
        },
        [_vm._v("CIRSmedical.de")]
      ),
      _vm._v("\n            wird über die Datei\n            "),
      _c("em", [_vm._v("riskop.properties")]),
      _vm._v(" gesteuert."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Ab\n            "),
      _c("strong", [_vm._v("riskop 1.4.0")]),
      _vm._v(" erfolgt das über den Eintrag EXTERNAL_CIRS:"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("# Valid values are NONE, CIRS_MEDICAL, CIRS_NETZ_DE."),
      _c("br"),
      _vm._v("EXTERNAL_CIRS=CIRS_MEDICAL"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Die URL, unter der riskop aufgerufen wird, z.B. "),
      _c("em", [
        _vm._v("http://riskopserver.local:8080/"),
        _c("strong", [_vm._v("Kontext-Name")]),
        _vm._v("/Start.do"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v('Beispiel: Neue Instanz "bsp_riskop"')]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [
        _vm._v(
          "Beenden Sie den installierten Tomcat, falls dieser noch läuft."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [
        _vm._v("Legen Sie in Ihrem DBMS eine neue Datenbank "),
        _c("strong", [_vm._v("bsp_riskop")]),
        _vm._v(
          " an (s.o.). Der DB-User kann\n                    für alles\n                    Instanzen aber der gleiche sein."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Weiterhin ist der\n                    "),
      _c("code", [_vm._v("FROM_NAME")]),
      _vm._v(" gemäß dem gewünschten Context-Namen anzupassen."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("FROM_NAME="),
      _c("strong", [_vm._v("bsp_riskop")]),
      _vm._v("\ndb.connection.url=jdbc:postgresql://localhost/"),
      _c("strong", [_vm._v("bsp_riskop")]),
      _vm._v("\ndb.connection.username=riskop\ndb.connection.password=riskop"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("p", [
        _vm._v(
          "Starten Sie den Tomcat wieder. Ab jetzt steht Ihnen die Riskop-Anwendung in zwei verschiedenen\n                    Tomcat-Kontexten\n                    zur Verfügung, zum Einen unter\n                    "
        ),
        _c("code", [_vm._v("riskop")]),
        _vm._v(" und zum Anderen auch unter\n                    "),
        _c("code", [_vm._v("bsp_riskop")]),
        _vm._v(
          ". Die beiden Installationen werden beim Zugriff durch die jeweilige URL\n                    unterschieden, gemäß\n                    dem Beispiel wären die einzelnen Anwendungen der neuen Installation folgendermaßen erreichbar:"
        ),
      ]),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "http://hier-rechnername-einsetzen:8080/bsp_riskop/admin/Start.do\nhttp://hier-rechnername-einsetzen:8080/bsp_riskop/team/Start.do\nhttp://hier-rechnername-einsetzen:8080/bsp_riskop/incidentreport/Start.do\n"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Die bereits bestehende Installation ist wie zuvor unter den folgenden URLs zu finden:"
        ),
      ]),
      _vm._v(" "),
      _c("pre", [
        _vm._v(
          "http://hier-rechnername-einsetzen:8080/riskop/admin/Start.do\nhttp://hier-rechnername-einsetzen:8080/riskop/team/Start.do\nhttp://hier-rechnername-einsetzen:8080/riskop/incidentreport/Start.do"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }